import { Component } from '@angular/core';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { PCIService } from 'src/app/Services/pci.service';

@Component({
  selector: 'app-pci',
  templateUrl: './pci.component.html',
  styleUrls: ['./pci.component.css'],
  providers: [PCIService],
})
export class PCIComponent {
  userdata?: UserData;
  rebcode: string | undefined;
  OBPortalSvcURL = '';
  PCIUrl: string | undefined;

  PCILinkInfo: string = '';
  PCILinkdata: any;
  constructor(
    private appConfigService: AppConfigService,
    private PCIService: PCIService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.rebcode = this.userdata?.rebcode;
    this.PCIUrl = this.appConfigService.PCIURL;
    this.getPCILink();
  }
  getPCILink() {
    this.PCILinkdata = this.PCIService.getBookingHash(this.rebcode).subscribe(
      (PCILinkdata) => this.setPCILink(PCILinkdata)
    );
  }

  setPCILink(resdata: any) {
    this.PCILinkdata = resdata;
    if (this.PCILinkdata.GetHashFromBookingCode.Result.Status == 'A') {
      this.PCILinkInfo = this.PCILinkdata.GetHashFromBookingCode.Hash;
    }
  }
}
